import { createDepartmentRequest } from "../../data/departmentApi";
import { validateDepartmentPayload } from "../validator/validateDepartmentPayload";

export async function createDepartmentUseCase(payload) {
  const error = validateDepartmentPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createDepartmentRequest(payload);
}
